import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RippleModule } from 'primeng/ripple';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { PerfilService } from '@/app/pages/service/perfil/perfil.service';
import { Router, RouterLink } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { MenuItem, MessageService } from 'primeng/api';
import { UsuarioService } from '@/app/pages/service/usuario/usuario.service';
import { MenuModule } from 'primeng/menu';

@Component({
    selector: '[app-menu-profile]',
    standalone: true,
    imports: [CommonModule, RippleModule, AvatarModule, MenuModule],
    template: `
    <div class="layout-menu-profile flex flex-row align-items-center p-3 cursor-pointer mb-6">
        <input #fileInput type="file" accept="image/*" class="hidden" (change)="changeProfilePhoto($event)" />
        <div class="relative group cursor-pointer" (click)="fileInput.click()" title="Alterar foto">
            @if (usuario?.foto) {
                <p-avatar [image]="usuario?.foto" shape="circle" size="large"></p-avatar>
            } @else {
                <p-avatar [label]="getInitialLetters(usuario?.nome)" shape="circle" size="large" [style]="getAvatarColor(usuario?.nome)"></p-avatar>
            }

            <div class="absolute inset-0 rounded-full bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                <i class="pi pi-camera text-white text-lg"></i>
            </div>
        </div>

        <div class="flex flex-col ml-2 gap-1" (click)="menuUsuario.toggle($event)">
            <span class="tracking-wide font-bold">{{ usuario?.nome }}</span>
            <span class="text-sm text-muted-foreground tracking-wide">
                {{ usuario?.perfil }}
            </span>
        </div>
        <p-menu #menuUsuario [model]="menuPerfil" [popup]="true" appendTo="body"></p-menu>
    </div>
    `,
})
export class AppMenuProfile {
    usuario: any;

    menuPerfil: MenuItem[] = [
        {
            label: 'Perfil',
            icon: 'pi pi-user',
            command: () => this.viewProfile()
        },
        {
            label: 'Sair',
            icon: 'pi pi-sign-out',
            command: () => this.logout()
        }
    ];
    
    constructor(
        private authService: AuthService,
        private usuarioService: UsuarioService,
        private messageService: MessageService,
        private router: Router
    ) {}
    
    ngOnInit() {
        this.loadProfile();
    }

    loadProfile() {
        this.usuario = this.authService.getUserLogged().result;
    }

    viewProfile() {
        this.router.navigate(['/configuracao/perfil-usuario']);
    }

    logout() {
        this.authService.logout();
    }

    getInitialLetters(nome?: string | null): string {
        if (!nome) return '?';

        const partesNome = nome
            .trim()
            .split(' ')
            .filter(Boolean);

        if (partesNome.length === 0) return '?';

        const primeiraLetra = partesNome[0].charAt(0);

        if (partesNome.length === 1) {
            return primeiraLetra.toUpperCase();
        }

        const segundaLetra = partesNome[partesNome.length - 1].charAt(0);

        return `${primeiraLetra}${segundaLetra}`.toUpperCase();
    }

    getAvatarColor(nome?: string | null): { [klass: string]: string } {
        const cores = [
            { backgroundColor: '#312e81', color: '#ffffff' },
            { backgroundColor: '#1d4ed8', color: '#ffffff' },
            { backgroundColor: '#034553', color: '#ffffff' },
            { backgroundColor: '#b45309', color: '#ffffff' },
            { backgroundColor: '#b91c1c', color: '#ffffff' },
            { backgroundColor: '#be185d', color: '#ffffff' },
            { backgroundColor: '#7c3aed', color: '#ffffff' },
            { backgroundColor: '#0f766e', color: '#ffffff' },
            { backgroundColor: '#0369a1', color: '#ffffff' },
            { backgroundColor: '#c2410c', color: '#ffffff' },
        ];

        if (!nome) return cores[0];

        const primeiraLetra = nome.trim().charAt(0).toUpperCase();

        const index = primeiraLetra.charCodeAt(0) % cores.length;

        return cores[index];
    }

    changeProfilePhoto(event: any): void {
        const file: File = event.target.files[0]; 
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                this.usuario.foto = reader.result as string;
                this.saveProfilePhoto(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    saveProfilePhoto(result: any) {
        this.usuarioService.trocarFoto(this.usuario).subscribe({
            next: (data) => {
                this._success(data);
            }, error: (err) => {
                this._message('Ocorreu um erro ao salvar a foto.', 'error', 'Erro');
            }
        })
    }

    _success(data: any) {
        data.messages.forEach((msg: any) => {
            if (msg.applicationMessageType === 0) {
                this._message(msg.message, "success", "Sucesso");
            }

            if (msg.applicationMessageType === 1) {
               this._message(msg.message, "error", "Erro");
            }

            if (msg.applicationMessageType === 2) {
                this._message(msg.message, "warn", "Alerta");
            }
        })
    }

    _message(message: string, severity: string, summary: string) {
         this.messageService.add({
            severity: severity,
            summary: summary,
            detail: message,
        });
    }
}